export const RESTART_AUTH_RESPONSE = 'RESTART_AUTH_RESPONSE';
export const LOADING = 'LOADING';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_ERROR = 'SIGNUP_ERROR';
export const CODE_ERROR = 'CODE_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_ERROR = 'LOGOUT_ERROR';
export const LOAD_PROFILE_SUCCESS = 'LOAD_PROFILE_SUCCESS';
export const LOAD_PROFILE_ERROR = 'LOAD_PROFILE_ERROR';
export const LOAD_USERS_LIST_SUCCESS = 'LOAD_USERS_LIST_SUCCESS';
export const LOAD_USERS_LIST_ERROR = 'LOAD_USERS_LIST_ERROR';
export const USER_DELETE_SUCCESS = 'LOAD_USERS_LIST_SUCCESS';
export const USER_DELETE_ERROR = 'LOAD_USERS_LIST_ERROR';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';
export const FREE_USER_STATE = 'FREE_USER_STATE';
export const LOAD_CUSTOMER_SUCCESS = 'LOAD_CUSTOMER_SUCCESS';
export const LOAD_CUSTOMER_ERROR = 'LOAD_CUSTOMER_ERROR';
export const COMPANY_STORE_SUCCESS = 'LOAD_CUSTOMER_SUCCESS';
export const COMPANY_STORE_ERROR = 'LOAD_CUSTOMER_ERROR';
export const CUSTOMER_GENERAL_INFO_STORE_SUCCESS = 'CUSTOMER_GENERAL_INFO_STORE_SUCCESS';
export const CUSTOMER_GENERAL_INFO_STORE_ERROR = 'CUSTOMER_GENERAL_INFO_STORE_ERROR';
export const APPLICATION_TEMPLATE_FIELDS_SUCCESS = 'APPLICATION_TEMPLATE_FIELDS_SUCCESS';
export const APPLICATION_TEMPLATE_GLOBAL_COUNTER = 'APPLICATION_TEMPLATE_GLOBAL_COUNTER';

export const APPLICATION_TEMPLATE_FIELDS_ERROR = 'APPLICATION_TEMPLATE_FIELDS_ERROR';

export const CUSTOMER_VIEW_FILE_SUCCESS = 'CUSTOMER_VIEW_FILE_SUCCESS';
export const CUSTOMER_VIEW_FILE_ERROR = 'CUSTOMER_VIEW_FILE_ERROR';
export const LOAD_COMPANIES_LIST_SUCCESS = 'LOAD_COMPANIES_LIST_SUCCESS';
export const LOAD_COMPANIES_LIST_ERROR = 'LOAD_COMPANIES_LIST_ERROR';
export const LOAD_APPLICATIONS_LIST_SUCCESS = 'LOAD_APPLICATIONS_LIST_SUCCESS';
export const LOAD_APPLICATIONS_LIST_ERROR = 'LOAD_APPLICATIONS_LIST_ERROR';

export const APPLICATION_STORE_SUCCESS = 'LOAD_CUSTOMER_SUCCESS';
export const APPLICATION_STORE_ERROR = 'LOAD_CUSTOMER_ERROR';
export const UPDATE_COMPANY_SUCCESS = 'UPDATE_COMPANY_SUCCESS';
export const UPDATE_COMPANY_ERROR = 'UPDATE_COMPANY_ERROR';
export const UPDATE_APPLICATION_SUCCESS = 'UPDATE_APPLICATION_SUCCESS';
export const UPDATE_APPLICATION_ERROR = 'UPDATE_APPLICATION_ERROR';
export const USERS_LIST_BY_ROLE_SUCCESS = 'USERS_LIST_BY_ROLE_SUCCESS';

export const USERS_LIST_BY_ROLE_ERROR = 'USERS_LIST_BY_ROLE_ERROR';
export const STORE_RELAY_SUCCESS = 'STORE_RELAY_SUCCESS';

export const LOAD_USER_SUCCESS = 'LOAD_USER_SUCCESS';
export const LOAD_USER_ERROR = 'LOAD_USER_ERROR';

export const STORE_RELAY_ERROR = 'STORE_RELAY_ERROR';

